import {ref} from "vue";
import {Api} from "@/service/api";

export function useGoogleSheets() {
    const connection = ref({
        name: '',
        files_source: [{tabs: [], tab: {}, clearHeader: false}],
        file_target: {tabs: [], tab: {}},
        filter: {
            conditions: [],
            conditionType: 'AND'
        },
    })

    async function reloadTabsSource(spreadsheet_id, tab) {
        let file_source = connection.value.files_source.find(
            file => file.id === spreadsheet_id && file.tabs.length === 0
        )

        if (file_source === undefined || file_source === null) {
            file_source = connection.value.files_source.find(
                file => file.id === spreadsheet_id && file.tab.sheetId === tab.sheetId
            )
        }

        file_source.isLoading = true
        file_source.tabs = await Api.getSpreadSheetTabs(spreadsheet_id);
        file_source.tab = file_source.tabs[0];
        file_source.isLoading = false
    }

    async function saveFilesSource(file, index) {
        file.tabs = []
        file.tab = {}
        file.clearHeader = false
        connection.value.files_source[index] = file
        await reloadTabsSource(file.id)
    }

    async function reloadTabsTarget() {
        connection.value.file_target.isLoading = true
        connection.value.file_target.tabs = await Api.getSpreadSheetTabs(connection.value.file_target.id);
        connection.value.file_target.tab = connection.value.file_target.tabs[0];
        connection.value.file_target.isLoading = false
    }

    async function saveFilesTarget(file) {
        file.tabs = []
        file.tab = {}

        connection.value.file_target = file

        await reloadTabsTarget()
    }

    return {
        connection,
        reloadTabsSource,
        reloadTabsTarget,
        saveFilesSource,
        saveFilesTarget,

    }
}